import { render, staticRenderFns } from "./CreatePracticeDialog.vue?vue&type=template&id=7202b8a2&"
import script from "./CreatePracticeDialog.vue?vue&type=script&lang=js&"
export * from "./CreatePracticeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports